<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
    <div>
        <button routerLink="add" class="btn btn-secondary">
            Add
        </button>
    </div>
    <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
        <div>
            <select id="inputStatus" class="min-w-40">
                <option value="Active">Active</option>
                <option value="InActive">Inactive</option>
            </select>
        </div>
        <div class="relative">
            <input type="text" required placeholder="Search.." class="pl-8" />
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
        </div>
    </div>

</div>


<div class="overflow-x-auto mt-4 pb-6 p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <table class="min-w-full table-auto border-collapse border  border-zinc-950/10 dark:border-white/10">
        <thead class="bg-zinc-950/5 dark:bg-white/5">
            <tr>
                <th
                    class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Action</th>
                <th
                    class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Name</th>
                <th
                    class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Key</th>
                <th
                    class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Type</th>
            </tr>
        </thead>
        <tbody>
            <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10" *ngFor="let document of documents">
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                    <div class="flex justify-start gap-2">
                      <button>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        </svg>
                      </button>
                      <button routerLink="{{document._id}}/edit" class="border-l border-zinc-300 px-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-zinc-500 dark:text-zinc-400">
                          <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>
                      </button>
                    </div>
                  </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{document.name}}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{document.key}}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{document.type}}</td>
            </tr>
        </tbody>
    </table>
</div>